import Item from './Item.js';
import Move from './Move.js';
import { globalItemDataStore } from '../OverworldAnimation.js';

export default class HM extends Item {
    constructor({ id }) {
        super({ id });
        const data = globalItemDataStore[id] ?? {};
        this.name = data.name ?? '';
        this.description = data.description ?? '';
        this.move = data.moveId ? Move.getById(data.moveId) : null;
        this.canBeHeld = false;
    }
}
